import { BaseOptionType } from "antd/lib/select";
import { AttendeeModel, AttendeeStatus, ForumGroupResponseModel } from "generated/api";

type AttendeeStatusFilterFields = Pick<AttendeeModel, "attendStatus">;
type PeopleTypeFilterFields = Pick<AttendeeModel, "peopleType">;
type GroupMembershipFilterFields = Pick<AttendeeModel, "groupMembership">;
type ForumGroupFilterFields = Pick<ForumGroupResponseModel, "id" | "name">;

const sortByLabel = (left: BaseOptionType, right: BaseOptionType) =>
  String(left.label).localeCompare(String(right.label));

export const getAttendeeStatusFilterValues = (attendees: AttendeeStatusFilterFields[]): AttendeeStatus[] =>
  Array.from(new Set(attendees.map(({ attendStatus }) => attendStatus))).sort((left, right) => left - right);

export const getPeopleTypeFilterOptions = (attendees: PeopleTypeFilterFields[]): BaseOptionType[] => {
  const peopleTypes = new Set(attendees.flatMap(({ peopleType }) => (peopleType ? [peopleType] : [])));

  return Array.from(peopleTypes, (peopleType) => ({ value: peopleType, label: peopleType })).sort(sortByLabel);
};

export const getGroupMembershipFilterOptions = (
  attendees: GroupMembershipFilterFields[],
  forumGroups: ForumGroupFilterFields[],
): BaseOptionType[] => {
  const attendeeGroupNames = new Set(attendees.flatMap(({ groupMembership }) => groupMembership ?? []));

  return forumGroups
    .filter(({ name }) => attendeeGroupNames.has(name))
    .map(({ id, name }) => ({ value: id, label: name }))
    .sort(sortByLabel);
};
